import { AMAP_TEMPLATES } from '@dtwin/shared';

// 2026-09-07｜天地图改走后端瓦片代理（服务端请求=无 Referer 服务端方式 + 服务端 key + IP 白名单留空，
// 免域名白名单，按 iotnobo-app TileProxy 逻辑）。前端不再直连天地图，tk 由后端注入。
const TILE_PROXY = '/api/v1/map/tile?layer={layer}&z={z}&y={y}&x={x}';

// 高德瓦片无需 key；key 用于高德 JS API / 搜索等场景
export const AMAP_KEY = import.meta.env.VITE_AMAP_KEY ?? '';
export const AMAP_SECURITY_CODE = import.meta.env.VITE_AMAP_SECURITY_CODE ?? '';

export interface AuthorizedBasemap {
  key: string;
  label: string;
  url: string;
}

// 2026-09-07｜GIS 图层：街道地图 + 卫星影像 + 注记叠加（天地图街道选后叠加「天地图 注记」即可显示道路名/地名标注）
export const AUTHORIZED_BASEMAPS: AuthorizedBasemap[] = [
  {
    key: 'tianditu_vec',
    label: '天地图 街道地图',
    url: TILE_PROXY.replace('{layer}', 'vec'),
  },
  {
    key: 'tianditu_cva',
    label: '天地图 注记',
    url: TILE_PROXY.replace('{layer}', 'cva'),
  },
  {
    key: 'tianditu_img',
    label: '天地图 卫星影像',
    url: TILE_PROXY.replace('{layer}', 'img'),
  },
  {
    key: 'amap_street',
    label: '高德 街道地图',
    url: AMAP_TEMPLATES.street,
  },
  {
    key: 'amap_img',
    label: '高德 卫星影像',
    url: AMAP_TEMPLATES.img,
  },
];

// 2026-09-07｜默认底图：高德卫星影像（稳定可用）；天地图 token 配置好后可在图层手动切换
export const DEFAULT_AUTHORIZED_IMAGERY_URL =
  AUTHORIZED_BASEMAPS.find((m) => m.key === 'amap_img')?.url || AMAP_TEMPLATES.img;

export const findAuthorizedBasemap = (key: string): AuthorizedBasemap | undefined =>
  AUTHORIZED_BASEMAPS.find((m) => m.key === key);